import { render, staticRenderFns } from "./examConfig.vue?vue&type=template&id=40bf4896&scoped=true&"
import script from "./examConfig.vue?vue&type=script&lang=js&"
export * from "./examConfig.vue?vue&type=script&lang=js&"
import style0 from "./examConfig.vue?vue&type=style&index=0&id=40bf4896&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bf4896",
  null
  
)

export default component.exports